module.exports = __webpack_public_path__ + "static/media/naga_siren.c054c1f6.png";